module.exports = __webpack_public_path__ + "icon-add.svg?fb0373962ec5e1c57e16bc3053272d10";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-add.svg
// module id = 614
// module chunks = 0